import Seta from '@assets/images/Seta.svg';
import { Link } from 'react-router-dom';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SectionThree.style';
import { useTranslation } from 'react-i18next';

const SectionThree = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('sectionThree.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>{t('sectionThree.paragraphOne')}</p>
        </TextBox1>
        <TextBox2>
          <TextBox2>
            <p>{t('sectionThree.paragraphTwo')}</p>
            <Link to="/segmentacoes" className="link-with-icon">
              {t('sectionThree.link')}
              <div>
                <img src={Seta} alt="Saiba Mais" />
              </div>
            </Link>
          </TextBox2>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionThree;
